import { useState } from "react";
import { toast } from "sonner";
import { Check, Pencil, X } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";
import { money } from "@/lib/format";

export default function CustomerPriceEditor({ o, onSaved }) {
  const api = useApi();
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const start = () => {
    setValue(o.customer_price ?? "");
    setEditing(true);
  };

  const save = async () => {
    const num = value === "" ? null : Number(value);
    if (num !== null && !(num > 0)) return toast.error("Enter a price above 0");
    setSaving(true);
    try {
      await api.patch(`/options/${o.id}/customer-price`, { customer_price: num });
      toast.success(num ? `Price to customer set to ${money(num, o.currency)}` : "Price to customer cleared");
      setEditing(false);
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <div className="flex flex-col items-end mt-1">
      <div className="flex items-center justify-end gap-1.5">
        <input type="number" min="1" step="0.01" autoFocus value={value} onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
          className="w-32 h-9 px-2 bg-[#0d0f14] border border-white/15 text-white text-sm text-right focus:outline-none focus:border-[#5B7FD1]"
          data-testid={`option-${o.rank}-customer-price-input`} />
        <button onClick={save} disabled={saving} className="p-2 text-[#5B7FD1] hover:text-white" aria-label="Save price" data-testid={`option-${o.rank}-customer-price-save-btn`}><Check size={15} /></button>
        <button onClick={() => setEditing(false)} className="p-2 text-zinc-500 hover:text-white" aria-label="Cancel" data-testid={`option-${o.rank}-customer-price-cancel-btn`}><X size={15} /></button>
      </div>
      <p className="text-[11px] text-zinc-600 mt-1 max-w-[260px] text-right leading-snug" data-testid={`option-${o.rank}-customer-price-tax-hint`}>Charter price before taxes. The customer PDF adds 7.5% FET and $5.30 per passenger, per leg.</p>
      </div>
    );
  }
  return (
    <button onClick={start} className="group inline-flex items-center gap-2 font-serif-display text-xl text-[#5B7FD1] whitespace-nowrap hover:text-white transition-colors"
      data-testid={`option-${o.rank}-customer-price`}>
      {o.customer_price ? money(o.customer_price, o.currency) : <span className="font-sans text-xs tracking-[0.15em] uppercase">Add price</span>}
      <Pencil size={12} className="opacity-60 group-hover:opacity-100" />
    </button>
  );
}
